import { render, staticRenderFns } from "./SchemaContent.vue?vue&type=template&id=4cf79c41&scoped=true"
import script from "./SchemaContent.vue?vue&type=script&lang=js"
export * from "./SchemaContent.vue?vue&type=script&lang=js"
import style0 from "./SchemaContent.vue?vue&type=style&index=0&id=4cf79c41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf79c41",
  null
  
)

export default component.exports